import React from 'react';
import '../../../../assests/css/admin/CustomerManagement/ViewProfileModal/ViewProfileModal.css';

const ViewProfileModal = ({ isOpen, onClose, customer }) => {
  if (!isOpen || !customer) return null;

  const initials = `${customer.firstname?.[0] || ''}${customer.lastname?.[0] || ''}`.toUpperCase();

  return (
    <div className="view-modal-overlay">
      <div className="view-modal-content">
        <div className="view-modal-header">
          <h2 className="view-modal-title">Customer Profile</h2>
          <button className="view-modal-close" onClick={onClose}>✕</button>
        </div>
        <div className="view-modal-body">
          <div className="view-profile-avatar">{initials}</div>
          <h3 className="view-profile-name">{customer.firstname} {customer.lastname}</h3>
          <p className="view-profile-id">ID: {customer.id}</p>
          
          <div className="view-profile-info">
            <div className="view-info-item">
              <label>Email</label>
              <p>{customer.email || "No Email"}</p>
            </div>
            <div className="view-info-item">
              <label>Phone</label>
              <p>{customer.phone || "No Phone"}</p>
            </div>
            <div className="view-info-item">
              <label>Status</label>
              <p>
                <span className={`view-status-badge view-status-${customer.status?.toLowerCase()}`}>
                  {customer.status || "Active"}
                </span>
              </p>
            </div>
            <div className="view-info-item">
              <label>Total Spent</label>
              <p>Rs. {customer.totalspent || 0}</p>
            </div>
            <div className="view-info-item">
              <label>Last Order</label>
              <p>{customer.lastorder || "No Orders Yet"}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ViewProfileModal;